export const MEMBER = {
  name: "recovery",
  path: "/v1/members/recover-member-identifier",
};

export const PAGE = {
  name: "page",
  path: "/v1/clients/member-identifier-recovery-form",
};



// WEBPACK FOOTER //
// ./src/components/member-identifier-recovery/memberIdentifierRecoveryModels.js